export enum localStorageKey {}

export enum sessionStorageKey {
    tokens = 'tokens',
    idpIdToken = 'idp.id_token',
}
